export const ProductTypeValue = Object.freeze({
  ChampionshipRing: 1,
  FashionRing: 2,
  Pendant: 3,
  Watch: 4,
  Bracelet: 5,
  DogTags: 6,
  CuffLinks: 7,
  TieTacs: 8,
  TShirt: 9,
  PolishingCloth: 10,
  StandardBox: 11,
  LedBox: 12,
  ProStyleBox: 13,
  BlackWoodBox: 14,
  CherryWoodBox: 15,
  MirrorBox: 16,
  WindowBox: 17,
  BasicPackage: 18,
  ChampionsPackage: 19,
  ChampionsPackage2021: 20,
  DynastyPackage: 21,
  Engraving: 22,
  MoldFee: 23,
  Taxes: 24,
  ThreeDVideo: 25,
  ArtworkFee: 26,
  ToolingFee: 27,
  Hoodie: 28,
  LongSleeveTee: 29,
  ShippingFee: 30,
  PriceIncrease: 31,
  JerseyNumberPendant: 32,
  OsrBox: 33,
  RosewoodWatchBox: 34,
  CustomRosewoodWatchBox: 35,
  MultiSlotBox: 36,
  LatePaymentFee: 37,
  Paperweight: 38,
  UltimatePackage: 39,
  Licensing: 40,
  Poster: 41,
  Discount: 42,
  CoachBundle: 43,
  DrawstringBag: 44,
  ChampionsPackage2023: 45,
  BarPendant: 46,
  MoneyClip: 47,
  TieClip: 48,
  FanRing: 49,
  SchoolPurchaseOrder: 50,
  ChampionsPlusPackage: 51,
  ChallengerCoin: 52,
  MirrorBoxSixSlots: 53,
  ChainSilver: 54,
  ChainGold: 55,
  ChainBlack: 56,
  MegaMirrorBox: 57,
  FoamRing: 58,
  ClassRing: 59,
  RemovableTopChampionshipRing: 60,
  RemovableTopCapsuleChampionshipRing: 61,
});

export const ProductTypeLabel = {
  [ProductTypeValue.ChampionshipRing]: "Championship Ring",
  [ProductTypeValue.FashionRing]: "Fashion Ring",
  [ProductTypeValue.Pendant]: "Pendant",
  [ProductTypeValue.Watch]: "Watch",
  [ProductTypeValue.Bracelet]: "Bracelet",
  [ProductTypeValue.DogTags]: "Dog Tags",
  [ProductTypeValue.CuffLinks]: "Cuff Links",
  [ProductTypeValue.TieTacs]: "Tie Tacs",
  [ProductTypeValue.TShirt]: "T-Shirt",
  [ProductTypeValue.PolishingCloth]: "Polishing Cloth",
  [ProductTypeValue.StandardBox]: "Standard Box",
  [ProductTypeValue.LedBox]: "LED Box",
  [ProductTypeValue.ProStyleBox]: "Pro-Style Box",
  [ProductTypeValue.BlackWoodBox]: "Black Wood Box",
  [ProductTypeValue.CherryWoodBox]: "Cherry Wood Box",
  [ProductTypeValue.MirrorBox]: "Mirror Box",
  [ProductTypeValue.WindowBox]: "Window Box",
  [ProductTypeValue.BasicPackage]: "Basic Package",
  [ProductTypeValue.ChampionsPackage]: "Champions Package",
  [ProductTypeValue.ChampionsPackage2021]: "2021 Champions Package",
  [ProductTypeValue.DynastyPackage]: "Dynasty Package",
  [ProductTypeValue.Engraving]: "Engraving",
  [ProductTypeValue.MoldFee]: "Mold Fee",
  [ProductTypeValue.Taxes]: "Taxes",
  [ProductTypeValue.ThreeDVideo]: "3D Video",
  [ProductTypeValue.ArtworkFee]: "Artwork Fee",
  [ProductTypeValue.ToolingFee]: "Tooling Fee",
  [ProductTypeValue.Hoodie]: "Hoodie",
  [ProductTypeValue.LongSleeveTee]: "Long Sleeve Tee",
  [ProductTypeValue.ShippingFee]: "Shipping Fee",
  [ProductTypeValue.PriceIncrease]: "Price Increase",
  [ProductTypeValue.JerseyNumberPendant]: "Jersey Number Pendant",
  [ProductTypeValue.OsrBox]: "OSR Box",
  [ProductTypeValue.RosewoodWatchBox]: "Rosewood Watch Box",
  [ProductTypeValue.CustomRosewoodWatchBox]: "Custom Rosewood Watch Box",
  [ProductTypeValue.MultiSlotBox]: "Multi-Slot Box",
  [ProductTypeValue.LatePaymentFee]: "Late Payment Fee",
  [ProductTypeValue.Paperweight]: "Paperweight",
  [ProductTypeValue.UltimatePackage]: "Ultimate Package",
  [ProductTypeValue.Licensing]: "Licensing",
  [ProductTypeValue.Poster]: "Poster",
  [ProductTypeValue.Discount]: "Discount",
  [ProductTypeValue.CoachBundle]: "Coach Bundle",
  [ProductTypeValue.DrawstringBag]: "Drawstring Bag",
  [ProductTypeValue.ChampionsPackage2023]: "2023 Champions Package",
  [ProductTypeValue.BarPendant]: "Bar Pendant",
  [ProductTypeValue.MoneyClip]: "Money Clip",
  [ProductTypeValue.TieClip]: "Tie Clip",
  [ProductTypeValue.FanRing]: "Fan Ring",
  [ProductTypeValue.SchoolPurchaseOrder]: "School Purchase Order",
  [ProductTypeValue.ChampionsPlusPackage]: "Champions+ Package",
  [ProductTypeValue.ChallengerCoin]: "Challenger Coin",
  [ProductTypeValue.MirrorBoxSixSlots]: "Mirror Box (6 Slots)",
  [ProductTypeValue.ChainSilver]: "Chain - Silver",
  [ProductTypeValue.ChainGold]: "Chain - Gold",
  [ProductTypeValue.ChainBlack]: "Chain - Black",
  [ProductTypeValue.MegaMirrorBox]: "Mega Mirror Box",
  [ProductTypeValue.FoamRing]: "Foam Ring",
  [ProductTypeValue.ClassRing]: "Class Ring",
  [ProductTypeValue.RemovableTopChampionshipRing]: "Removable Top Championship Ring",
  [ProductTypeValue.RemovableTopCapsuleChampionshipRing]: "Removable Top Capsule Championship Ring",
};
